<script>
import ActiveOrderItem from './order-item/ActiveOrderItem'
import ArchivedOrderItem from './order-item/ArchivedOrderItem'

export default {
  name: 'OrderItem',
  components: { ActiveOrderItem, ArchivedOrderItem },
  props: {
    order: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <v-layout class="mb-3">
    <!-- Active order -->
    <v-layout v-if="order.status === 'PENDING'">
      <ActiveOrderItem :order="order" />
    </v-layout>

    <!-- Archived order -->
    <v-layout v-else>
      <ArchivedOrderItem :order="order" />
    </v-layout>
  </v-layout>
</template>

<style scoped lang="sass">
.v-card, .layout
  width: 100%
</style>
